export const SMALL_SCREEN_WIDTH = '576px';
export const MEDIUM_SCREEN_WIDTH = '768px';
export const LARGE_SCREEN_WIDTH = '992px';
export const MOBILE_SCREEN_SIZE = 768;

// Google Ads "Purchase" conversion action (tag AW-18408775748 is loaded in public/index.html).
export const GOOGLE_ADS_PURCHASE_CONVERSION = 'AW-18408775748/PPLJCJnSx4EdEMTA_slE';

export const SPORTS = ['mlb', 'nfl', 'nhl', 'nba', 'cfb', 'cbb'];

// Signed-in app routes: auth-gated in SubscriptionGate and rendered with the dark header.
const APP_ROUTE_PREFIXES = ['/sports', '/settings', '/profile', '/props', '/subscription-management'];
export const isAppRoute = path => APP_ROUTE_PREFIXES.some(prefix => path.startsWith(prefix));

export const SPORT_ICON_MAP = {
    mlb: 'fa-baseball-ball',
    nfl: 'fa-football-ball',
    nhl: 'fa-hockey-puck',
    nba: 'fa-basketball-ball',
    cfb: 'fa-football-ball',
    cbb: 'fa-basketball-ball',
};

export const SOCIAL_LINKS = {
    x: 'https://x.com/ProvenWinners?lang=en',
    instagram: 'https://www.instagram.com/provenwinner/?hl=en',
    winible: 'https://www.winible.com/provenwinner',
};

export const APP_STORE_LINKS = {
    ios: 'https://apps.apple.com/us/app/proven-winner-predict/id6792782624',
    // Placeholder until the Play Store listing is live
    android: 'https://play.google.com/store/apps/details?id=com.kwaggoner00.provenwinnerpredict',
};

export const All_FILTERS = [
    {
        id: 'road-dogs',
        label: 'Road Dogs',
        desc: 'These are dogs on the road.',
    },
    {
        id: 'home-favs',
        label: 'Home Favorites',
        desc: 'This chart examines how often home favorites produce winning moneyline tickets.',
    },
    {
        id: 'road-favorites',
        label: 'Road Favorites',
        desc: 'These teams are favored despite not being at home.',
    },
    {
        id: 'division-game',
        label: 'Division Games',
        desc: 'Games in which the teams are in the same division.',
    },
    {
        id: 'conference-game',
        label: 'Conference Games',
        desc: 'Games in which the teams are in the same conference.',
    },
];
